import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BsModalRef, ModalModule} from 'ngx-bootstrap/modal';
import {JwtParserService} from '../../shared/services/jwt-parser.service';
import {AuthGuard} from '../../shared/services/auth.guard';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor} from '../../shared/services/interceptor/api.interceptor';
import {ModalService} from '../../shared/services/modal.service';
import {SharedModule} from '../../shared/shared.module';
import {ConfirmationSummaryComponent} from './confirmation-summary/confirmation-summary.component';
import {ConfirmationRoutingModule} from './confirmation-routing.module';
import {
    CustomerDetailsConfirmationComponent
} from './customer-details-confirmation/customer-details-confirmation.component';
import {
    SavingsSummaryConfirmationComponent
} from './savings-summary-confirmation/savings-summary-confirmation.component';
import {FreshpassPerksComponent} from './freshpass-perks/freshpass-perks.component';
import {FreshpassBenefitsComponent} from './freshpass-benefits/freshpass-benefits.component';
import {TermsComponent} from './terms/terms.component';
import {VipHelpComponent} from './vip-help/vip-help.component';
import {CouponItemComponent} from './coupon-item/coupon-item.component';
import {CreditPreviewComponent} from './credit-preview/credit-preview.component';
import {MilestoneCelebrationModalComponent} from './milestone-celebration-modal/milestone-celebration-modal.component';
import {SnackBarComponent} from "../../shared/components/snack-bar/snack-bar.component";
import { FreshpassLtoComponent } from './freshpass-lto/freshpass-lto.component';
import { DealsCarouselModule } from "abs-ngx-library/src/lib/deals-carousel"
import { ProductUtilService } from 'abs-ngx-library/src/lib/core';
import { ConfirmationNotificationsComponent } from './confirmation-notifications/confirmation-notifications.component';


@NgModule({
    declarations: [
        ConfirmationSummaryComponent,
        CustomerDetailsConfirmationComponent,
        SavingsSummaryConfirmationComponent,
        FreshpassBenefitsComponent,
        FreshpassPerksComponent,
        TermsComponent,
        VipHelpComponent,
        CouponItemComponent,
        CreditPreviewComponent,
        MilestoneCelebrationModalComponent,
        SnackBarComponent,
        FreshpassLtoComponent,
        ConfirmationNotificationsComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ConfirmationRoutingModule,
        ModalModule.forRoot(),
        SharedModule,
        DealsCarouselModule
    ],
    exports: [],
    providers: [ProductUtilService, JwtParserService, AuthGuard, {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    },
        ModalService, BsModalRef],
    schemas: [NO_ERRORS_SCHEMA]
})
export class ConfirmationModule {
}
